module.exports = __webpack_public_path__ + "static/media/np.27b4a3ed.png";